enum SentreeEventTypes {
    superheatHigh = "Superheat High",
    superheatLow = "Superheat Low",
    subcoolHigh = "Subcool High",
    subcoolLow = "Subcool Low",
    badInstall = "Bad Install",
    steadyState = "Steady State",
}

export default SentreeEventTypes;